import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { makeStyles } from '@material-ui/core/styles';
import { useSnackbar } from 'notistack';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { Checkbox, FormLabel } from '@material-ui/core';
import ProviderTooltip from './Tooltips.jsx';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  formControl: {
    margin: theme.spacing(1),
  },
}));

function ProvidersCheckBoxes(props) {
  const classes = useStyles();
  const {
    checkedProviderIds,
    providerCalRefs,
    providersById,
    toggleCheckbox,
    filterList,
    filterListUpdate,
    selectedDate,
  } = props;

  const { enqueueSnackbar } = useSnackbar();
  const [filterIds, setFilterIds] = useState(null);

  useEffect(() => {
    filterOptions();
  }, [filterList]);

  const filterOptions = async () => {
    let arr = [];
    filterList.map(async (item, i) => {
      if (item.isChecked) {
        arr.push(item.id);
      }
    });
    setFilterIds(arr);
  };

  const numChecked = filterIds?.length;
  const targetRowLength = 5;
  const uncheckBox = event => {
    if (numChecked > 1) {
      const id = event.target.name || event.target.value;
      const checkedState = event.target.checked;
      const updateFilterArray = filterList.map((inVal, i) => {
        if (inVal.id === id) {
          return { ...inVal, isChecked: event.target.checked };
        }
        return inVal;
      });
      filterListUpdate(updateFilterArray);
      filterOptions();
      toggleCheckbox(id, checkedState, 'check-box');
    } else {
      enqueueSnackbar(`Minimum 1 schedule at a time.`, {
        preventDuplicate: true,
        autoHideDuration: 3000,
      });
    }
  };

  const atLastRow = index => {
    return index === numChecked - (numChecked % targetRowLength);
  };

  const getLastRowPrividers = index => {
    let lastRowProviders = [];
    for (let i = index; i < numChecked; i++) {
      const id = filterIds[i];
      const provider = providersById[id];
      lastRowProviders.push(provider);
    }
    return lastRowProviders;
  };

  const rowHasTargetLength = index => {
    return (index + 1) % targetRowLength === 0;
  };

  const getTargetRowProviders = index => {
    const targetRowProviders = [];
    const start = index - targetRowLength + 1;
    for (let i = start; i <= index; i++) {
      const id = filterIds[i];
      const provider = providersById[id];
      targetRowProviders.push(provider);
    }
    return targetRowProviders;
  };

  const maskingProviderNames = name => {
    let ProviderName = name.length > 25 ? `${name.slice(0, 25)}...` : name;
    return ProviderName;
  };

  const today= new Date();
  const isTodayOrFutureDate=selectedDate.setHours(0,0,0,0) >= today.setHours(0,0,0,0)

  const renderRow = (providers, index) => {
    return (
      <div className="checkbox-row" key={`row-${index}`}>
        {providers.map(provider => {
          const { id, apptCount } = provider;
          // console.log(apptCount, 'apptcount')
          return (
            <>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <ProviderTooltip
                  title={`${provider.name} ${provider.zipcodeData}`}
                  enterTouchDelay={300}
                  key={`tooltip-${id}`}
                >
                  <FormControlLabel
                    className="checkbox"
                    control={
                      <Checkbox
                        checked={!!providerCalRefs[id]}
                        checked={provider.id}
                        onChange={uncheckBox}
                        name={id}
                      />
                    }
                    label={maskingProviderNames(provider.name)}
                  />
                </ProviderTooltip>
                
                {(isTodayOrFutureDate)?<label style={{ marginTop: '-10px' }}>{provider?.apptCount}</label>:(provider?.apptCount ? provider?.apptCount : null)}
                
              </div>
            </>
          );
        })}
      </div>
    );
  };

  return numChecked < targetRowLength ? (
    <div className={classes.root}>
      <FormControl component="fieldset" className={classes.formControl}>
        <div className="checkbox-row">
          {filterIds?.map(id => {
            const provider = providersById[id];

            return (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <ProviderTooltip
                  key={`tooltip-${id}`}
                  title={provider.name}
                  enterTouchDelay={300}
                >
                  <FormControlLabel
                    className="checkbox"
                    control={
                      <Checkbox
                        checked={!!providerCalRefs[id]}
                        checked={provider.id}
                        onChange={uncheckBox}
                        name={id}
                      />
                    }
                    label={maskingProviderNames(provider.name)}
                  />
                </ProviderTooltip>
                {isTodayOrFutureDate?<label style={{ marginTop: '-10px' }}>{provider?.apptCount}</label>:null}
              </div>
            );
          })}
        </div>
      </FormControl>
    </div>
  ) : (
    <div className={classes.root}>
      <FormControl component="fieldset" className={classes.formControl}>
        {filterIds?.map((_, index) => {
          if (atLastRow(index) && !rowHasTargetLength(index)) {
            const lastRowProviders = getLastRowPrividers(index);
            return renderRow(lastRowProviders, index);
          } else if (rowHasTargetLength(index)) {
            const targetRowProviders = getTargetRowProviders(index);
            return renderRow(targetRowProviders, index);
          }
        })}
      </FormControl>
    </div>
  );
}

export default ProvidersCheckBoxes;
